










import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  head: {
    script: [
      { src: '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js' },
    ],
  },
})
export default class DaumPostcode extends Vue {
  @Prop({ default: '' }) q: any
  @Prop({ default: false }) animation: any
  @Prop({ default: true }) autoMapping: any
  @Prop({ default: true }) shorthand: any
  @Prop({ default: 0 }) pleaseReadGuide: any
  @Prop({ default: 1.5 }) pleaseReadGuideTimer: any
  @Prop({ default: 10 }) maxSuggestItems: any
  @Prop({ default: false }) showMoreHName: any
  @Prop({ default: false }) hideMapBtn: any
  @Prop({ default: false }) hideEngBtn: any
  @Prop({ default: false }) alwaysShowEngAddr: any
  @Prop({ default: false }) zonecodeOnly: any
  @Prop({ default: () => ({}) }) theme: any
  isOpen = false

  style = {
    height: '0',
  }

  async init() {
    const daum = await (window as any).daum
    if (daum && daum.Postcode != null) {
      this.$nextTick(() => {
        new daum.Postcode({
          width: '100%',
          height: '100%',
          animation: this.animation,
          autoMapping: !this.autoMapping,
          shorthand: !this.shorthand,
          pleaseReadGuide: this.pleaseReadGuide,
          pleaseReadGuideTimer: this.pleaseReadGuideTimer,
          maxSuggestItems: this.maxSuggestItems,
          showMoreHName: this.showMoreHName,
          hideMapBtn: this.hideMapBtn,
          hideEngBtn: this.hideEngBtn,
          alwaysShowEngAddr: this.alwaysShowEngAddr,
          zonecodeOnly: this.zonecodeOnly,
          theme: this.theme,
          oncomplete: (data: any) => {
            this.$emit('complete', data)
          },
          onresize: (size: any) => {
            this.style = { height: `${size.height}px` }
          },
        }).embed(this.$refs.postcodeContainer, {
          q: this.q,
          autoClose: false,
        })
      })
    }
  }

  mounted() {
    if (process.client) {
      this.init()
    }
  }
}
